import { maxLength, minLength, pipe, regex, string } from "valibot";

export const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const slugField = pipe(
  string(),
  minLength(1, "Slug is required"),
  maxLength(255, "Slug cannot exceed 255 characters"),
  regex(
    SLUG_REGEX,
    "Slug must contain only lowercase letters, numbers, and hyphens"
  )
);
